const initialState = [];

const reductions = {
  NEW_AGENT_TEAM: function (state, action) {
    const foundAgentTeam = state.find((c) => c.id === action.payload.id);
    if (foundAgentTeam) {
      return state;
    }
    return state.concat(action.payload);
  },
  DELETE_AGENT_TEAM: function (state, action) {
    return state.filter((c) => c.id !== action.payload.id);
  },
  NEW_AGENT_TEAMS: function (state, action) {
    return state.concat(action.payload);
  },
};

const agentTeamsReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default agentTeamsReducer;
